import { render } from "./index.vue?vue&type=template&id=93771180&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=93771180&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93771180"]])

export default __exports__